export { default } from './FocusLock';
